//import { Card, CardTitle } from "../components/Card";

export default function JoinUs() {
  return (
    <h1>Join Us</h1>
  );
}